import { render, staticRenderFns } from "./MedicionSeveridadPagination.vue?vue&type=template&id=9925e76a&"
import script from "./MedicionSeveridadPagination.vue?vue&type=script&lang=js&"
export * from "./MedicionSeveridadPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports